import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M1 8h14" stroke="currentcolor" stroke-linejoin="bevel"/><path d="M10 2.983L15 8l-5 5.017" stroke="currentcolor"/></svg>`;

export { symbol as default };
